// NATIVE

// INSTALLED

// CUSTOM
import { checkingPreload, unCheckingPreload } from '../loading';
import {
  setPermissionsList,
  setPermissionListSelect,
  setPermissionDetail,
} from './permissionsSlice';
import {
  getAllPermissionsService,
  createPermissionService,
  updatePermissionService,
  getPermissionDetailService,
  deletePermissionService,
  restorePermissionService,
} from '../../services/permissions.service';

import { QueryPagination } from '../../commons/interfaces';

export const getAllPermissionsStore =
  (query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await getAllPermissionsService(query);

      if (response.ok) {
        dispatch(setPermissionsList(response.data));
        dispatch(setPermissionListSelect(response.data));
      }

      return response;
    } catch (error) {
      console.error(error);

      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const getPermissionDetailStore = (id: string) => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response = await getPermissionDetailService(id);

    if (response.ok) {
      dispatch(setPermissionDetail(response.data));
    }

    return response;
  } catch (error) {
    console.error(error);

    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const savePermissionStore = (data: any) => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response = await createPermissionService(data);

    if (response.ok) {
      dispatch(setPermissionsList(response.data));
    }

    return response;
  } catch (error) {
    console.error(error);

    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const updatePermissionStore = (id: string, data: any) => async (dispatch: any) => {
  dispatch(checkingPreload());

  try {
    const response = await updatePermissionService(id, data);

    return response;
  } catch (error) {
    console.error(error);

    return error;
  } finally {
    dispatch(unCheckingPreload());
  }
};

export const deletePermissionStore =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await deletePermissionService(id, query);

      if (response.ok) {
        dispatch(setPermissionsList(response.data));
      }

      return response;
    } catch (error) {
      console.error(error);

      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };

export const restorePermissionStore =
  (id: string, query: QueryPagination = {}) =>
  async (dispatch: any) => {
    dispatch(checkingPreload());

    try {
      const response = await restorePermissionService(id, query);

      if (response.ok) {
        dispatch(setPermissionsList(response.data));
      }

      return response;
    } catch (error) {
      console.error(error);

      return error;
    } finally {
      dispatch(unCheckingPreload());
    }
  };
